import { View }                                  from 'react-native';
import { Image,Text,useTheme,Button,Icon}             from '@rneui/themed';
import Carousel                                  from 'react-native-reanimated-carousel';
import { ImageWithOptionalOverlay }              from '../../common';
import splashLogo                                from '../../../../assets/images/icon.png';
import { useDeviceInfo }                         from '../../../hooks';
import { ScrollView }                            from 'react-native-gesture-handler';
import { format, parseISO }                      from 'date-fns';
import Utils from '../../../common/Utils'





const EventScreen = () => {
    const {width,isLandscape}                          = useDeviceInfo()
    const {theme}                                      = useTheme()
    // const imageSource                               = 'https://jhm-cms.images.sardius.media/media/vbdcrq3z/web-event-full_nwmk.jpg';
    const imageSource                                  = 'https://jhm-cms.images.sardius.media/media/cbjhypwc/biblestudy.jpg'
    const enableImageOverlay                           = false;
    const imageHeight                                  = 250;//Due to the graphic design title being cutoff heights needed to be adjusted
    const text                                         = 'TEST Event Grid Title';
    const textColor                                    = '#fff';
    const logoUrl                                      = undefined
    const eventDescription                             =`Let’s get “Back to the Basics” as we explore the foundations of our faith through this powerful teaching series with Pastor Matt Hagee on Sunday Nights.Let’s get “Back to the Basics” as we explore the foundations of our faith through this powerful teaching series with Pastor Matt Hagee on Sunday Nights.Let’s get “Back to the Basics” as we explore the foundations of our faith through this powerful teaching series with Pastor Matt Hagee on Sunday Nights.Let’s get “Back to the Basics” as we explore the foundations of our faith through this powerful teaching series with Pastor Matt Hagee on Sunday Nights.

Let’s get “Back to the Basics” as we explore the foundations of our faith through this powerful teaching series with Pastor Matt Hagee on Sunday Nights.`

// HARDCODED FOR NOW BUT ESSENTIALLY WILL COME FROM EVENTS FROM SERVER
    const events =[
            'https://jhm-cms.images.sardius.media/media/cx1c4fn5/web-event-full_scc.jpg',
            'https://jhm-cms.images.sardius.media/media/0omgwb45/cc_israeltour23_webevent-1680x945.jpg',
            'https://jhm-cms.images.sardius.media/media/qbvhqahp/feast23_sacc_1680x945.jpg',
            'https://jhm-cms.images.sardius.media/media/x3vfknxb/230903-faithordysfunction-series-fullwidth-1680x945.jpg'
    ]
		const startDate    		= '2023-09-27T09:00:00';
        const eventTitle        ='Embraced Ladies Bible Study'
        const isAllDay          = true
        const dateTimeFormat    = Utils.formatDateTimeShow30MinOrNot(startDate,isAllDay)
        const ministry          = ['Embraced Women’s Ministry']

  return (
        <View style={{flex:1,backgroundColor:theme?.colors?.navy}}>
            <ImageWithOptionalOverlay 
                                    childContainerStyle={{ 
                                                            height: '100%', 
                                                            justifyContent: 'center',
                                                            width: '100%',
                                                        }}
                                    enableOverlay={enableImageOverlay}
                                    containerStyle={{
                                        // flex:1,
                                        // width:width,
                                                        // borderColor:'green',
                                                        // borderWidth:5,
                                                    }}
                                    imagePath={imageSource}
                                    imageHeight={imageHeight}
                                    testID='Mobile.EventScreen.ImageWithOptionalOverlay'
                                    resizeMode={'cover'}
                                    >
                                        <View style={{justifyContent:'center',
                                                    flexDirection:'row',
                                                    position:'relative',
                                                    //   borderColor:'orange',
                                                    //   borderWidth:1
                                                    }}>
                                            <Text numberOfLines={1} 
                                                style={{fontSize:40,
                                                        color: textColor || theme?.colors?.white,
                                                        position:'absolute',
                                                        right:0,
                                                        top:-60,
                                                        left:0
                                                        }}
                                                        >
                                                            { text }
                                            </Text>
                                        </View>
                                        <View style={{marginLeft:10, position:'relative',top:75}}>
                                            <View style={{width:'100%'}}>
                                                <View style={{flexDirection:'row',alignItems:'center', width:'100%'}}>
                                                    <Image source={logoUrl?.length > 0 ? {uri:`https:${logoUrl}`}: splashLogo}
                                                        alt={'Mobile Event screen Cornerstone Logo'} 
                                                        style={{height:25,width:25,resizeMode:'contain',borderRadius:15,marginBottom:10}}
                                                        /> 
                                                    <Text style={{paddingLeft:4,paddingBottom:8,fontSize:10,letterSpacing:3,color:theme?.colors?.white }}>EVENTS</Text>
                                                </View>
                                            <View style={{flexDirection:'row',alignItems:'center'}}> 
                                                <Button title="Like"
                                                        buttonStyle={{borderRadius: 6,backgroundColor: 'rgba(255, 255, 255, 0.15)'}}
                                                        size='md'
                                                        containerStyle={{marginRight: 10,justifyContent:'center',alignItems:'center'}}
                                                        titleStyle={{ fontSize:10,color:theme?.colors?.white }}
                                                        icon={{
                                                            name: 'thumbs-up',
                                                            type:(theme?.iconKit || 'font-awesome-5'),
                                                            size: 15,
                                                            color: 'white',
                                                        }}
                                                        iconLeft
                                                        iconContainerStyle={{ marginRight: 10 }}
                                                        />
                                                <Button title="Share"
                                                        buttonStyle={{ borderRadius: 6,backgroundColor: 'rgba(255, 255, 255, 0.15)'}}
                                                        size='md'
                                                        containerStyle={{
                                                        // width: 75,
                                                        }}
                                                        titleStyle={{ fontSize:10,color:theme?.colors?.white }}
                                                        icon={{
                                                            name: 'share',
                                                            type:(theme?.iconKit || 'font-awesome-5'),
                                                            size: 15,
                                                            color: 'white',
                                                        }}
                                                        iconLeft
                                                        iconContainerStyle={{ marginRight: 10 }}
                                                        />
                                                <Button title="Schedule"
                                                        buttonStyle={{ borderRadius: 6,backgroundColor: 'rgba(255, 255, 255, 0.15)'}}
                                                        size='md'
                                                        containerStyle={{
                                                        // width: 75,
                                                        marginLeft: 10,
                                                        }}
                                                        titleStyle={{ fontSize:10,color:theme?.colors?.white }}
                                                        icon={{
                                                            name: 'calendar',
                                                            type:(theme?.iconKit || 'font-awesome-5'),
                                                            size: 15,
                                                            color: 'white',
                                                        }}
                                                        iconLeft
                                                        iconContainerStyle={{ marginRight: 3 }}
                                                        />
                                                </View>
                                        </View>

                                        </View>
            </ImageWithOptionalOverlay>
            <View style={{flexDirection:'row',
                        flexWrap:'wrap',
                        justifyContent:'center',
                        // width:'100%'
                        // borderColor:'blue',
                        // borderWidth:1,
                        }}>
                <View style={{backgroundColor:theme?.colors.navyDark,
                            height:165,
                            borderRadius:4,
                            margin:theme?.margins?.gutter-5,
                            paddingHorizontal:10,
                            paddingVertical:10,
                            alignItems:'center',
                            marginBottom:10
                            }}>
                    <ScrollView >
                            <Text numberOfLines={1} 
                                style={{fontSize:16,fontWeight:700,textAlign:'left',width:'100%',paddingBottom:10,
                                        color: textColor || theme?.colors?.white
                                }}
                                >
                                    Knight with my Night
                            </Text>
                            <Text style={{fontSize:13,
                                        color: textColor || theme?.colors?.white,
                                        paddingBottom:10
                                        }}
                                        >
                                            {eventDescription}
                            </Text>
                            <Text style={{fontSize:13,
                                        opacity:0.75,
                                        color: textColor || theme?.colors?.white,
                                        }}
                                        >
                                        Knight with my the Night
                            </Text>
                            <Text style={{fontSize:13,
                                        opacity:0.75,
                                        color: textColor || theme?.colors?.white,
                                        paddingBottom:10
                                        }}
                                        >
                                            Tuesday September 26th, 2023, 8 pm
                            </Text>
                    </ScrollView>
                </View>
                <View style={{ alignItems:'center',width:'100%'}}>
                    <View style={{flexDirection:'row', width:'100%',marginLeft:theme?.margins?.gutter}}>
                        <Text style={{color: textColor || theme?.colors?.white, }}>October</Text>
                    <Icon name='caret-down'
                          size={20}
                          color={theme?.colors?.white}
                          type={theme?.iconKit || 'font-awesome-5'}
                          containerStyle={{paddingHorizontal:8}}
                        //   solid
                          onPress={()=> console.log('search for something')}
                          />
                    {/* <Image source={logoUrl?.length > 0 ? {uri:`https:${logoUrl}`}: splashLogo}
                                                    alt={'Mobile Event screen Cornerstone Logo'} 
                                                    style={{height:25,width:25,resizeMode:'contain',borderRadius:15,marginBottom:10}}
                                                    /> */}
                    </View>
                    <Carousel
                        loop
                        width={width}
                        height={width / 2}
                        autoPlay={true}
                        data={events}
                        mode='parallax'
                        scrollAnimationDuration={3000}
                        onSnapToItem={(index) => console.log('current index:', index)}
                        renderItem={({item} ) => (
                            <ImageWithOptionalOverlay 
                                imagePath={item}
                                containerStyle={{flex:1,
                                                borderWidth: 1,
                                                borderRadius:16,
                                                borderColor:theme?.colors?.transparent,
                                                justifyContent: 'center',
                                                alignItems:'center'
                                                }}
                                                >
                                                    <View style={{ left: theme?.margins?.gutter, position: 'absolute', top:theme?.margins?.gutter }}>
                                                            <View style={theme?.appComponents?.umbraco?.EventsGrid?.eventDateBubble}>
                                                                <Text numberOfLines={1} style={theme?.appComponents?.umbraco?.EventsGrid?.eventDay}>
                                                                    { format(typeof startDate === 'string' ? parseISO(startDate) : new Date(startDate), 'dd') }
                                                                </Text>
                                                                <Text numberOfLines={1} style={theme?.appComponents?.umbraco?.EventsGrid?.eventMonth}>
                                                                    { format(typeof startDate === 'string' ? parseISO(startDate) : new Date(startDate), 'MMM') }
                                                                </Text>
                                                            </View>
                                                    </View>
                                                    <View style={{ left: theme?.margins?.gutter, position: 'absolute', bottom: theme?.margins?.gutter }}>
                                                        <View style={theme?.appComponents?.umbraco?.EventsGrid?.eventDetails}>
                                                            <Text numberOfLines={1} style={theme?.appComponents?.umbraco?.EventsGrid?.eventTitle}>
                                                                { eventTitle }
                                                            </Text>
                                                            <Text numberOfLines={1} style={theme?.appComponents?.umbraco?.EventsGrid?.eventText}>
                                                                { dateTimeFormat }
                                                            </Text>
                                                            <Text numberOfLines={1} style={theme?.appComponents?.umbraco?.EventsGrid?.eventText}>
                                                                { ministry }
                                                            </Text>
                                                        </View>
                                                    </View>
                            </ImageWithOptionalOverlay>
                            )}
                            />
                </View>
            </View>
    </View> 

  )
}

export default EventScreen